import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./protected-route";
import { Error } from "pages/error/error";
import React from "react";
import { Box } from "@mui/material";
import { LoadingIndicator } from "AttendanceForm/Components/LoadingIndicator/LoadingIndicator";
import ScrollToTop from "components/scroll-to-top/scroll-to-top";
import { BookingJourney_Paths } from "utils/constants";
import portalSettingsManager from "utils/portalSettingsManager";
import { LearningRequest } from "pages/learningRequest/learningRequest";

const Product = React.lazy(() =>
  import("pages/product/product").then((module) => ({ default: module.Product })),
);

const Search = React.lazy(() =>
  import("pages/search/search").then((module) => ({ default: module.Search })),
);

const SearchV2 = React.lazy(() =>
  import("pages/search/searchV2").then((module) => ({ default: module.SearchV2 })),
);

const CourseV2 = React.lazy(() =>
  import("pages/course/CourseV2").then((module) => ({ default: module.CourseV2 })),
);

const BookingForm = React.lazy(() =>
  import("pages/bookingJourney/bookingForm").then((module) => ({ default: module.BookingForm })),
);

const MyBookingsPage = React.lazy(() =>
  import("pages/mybookings/mybookings-page").then((module) => ({ default: module.MyBookingsPage })),
);

export interface RouteField {
  path: string;
  component: React.FC;
}

const isBookingJourneyEnabled = () =>
  portalSettingsManager?.application?.features?.enableBookingJourney;

const routes: RouteField[] = [
  {
    path: "/subjectarea/:id",
    component: Product,
  },
  {
    path: "/subject/:id",
    component: Product,
  },
  {
    path: "/search",
    component: Search,
  },
  {
    path: "/searchV2",
    component: SearchV2,
  },
  {
    path: "/courseView/:id",
    component: CourseV2,
  },
  {
    path: "/mybookings",
    component: MyBookingsPage,
  },
  {
    path: `${BookingJourney_Paths.BookingJourney}/:id`,
    component: isBookingJourneyEnabled ? BookingForm : Error,
  },
  {
    path: `${BookingJourney_Paths.BookingJourney}`,
    component: isBookingJourneyEnabled ? BookingForm : Error,
  },
  {
    path: "/learningRequest",
    component: LearningRequest,
  },
];

export const IBFRoutes = () => {
  return (
    <React.Suspense
      fallback={
        <Box display="flex" justifyContent="center">
          <LoadingIndicator size="3rem" color="primary" />
        </Box>
      }
    >
      <ScrollToTop />
      <Routes>
        {routes.map((route) => (
          <Route
            path={route.path}
            key={route.path}
            element={
              <ProtectedRoute>
                <route.component />
              </ProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<Error />} />
      </Routes>
    </React.Suspense>
  );
};
